import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Dismissed = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.833252"
        y="0.833496"
        width="18.3333"
        height="18.3333"
        rx="9.16667"
        fill="url(#paint0_linear_2312_41422)"
      />
      <rect x="1.33325" y="1.3335" width="17.3333" height="17.3333" rx="8.66667" stroke="black" strokeOpacity="0.08" />
      <g filter="url(#filter0_di_2312_41422)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.82392 6.88433C5.53103 6.59144 5.53103 6.11657 5.82392 5.82367C6.11681 5.53078 6.59169 5.53078 6.88458 5.82367L10.0001 8.93918L13.1156 5.82367C13.4085 5.53078 13.8834 5.53078 14.1762 5.82367C14.4691 6.11657 14.4691 6.59144 14.1762 6.88433L11.0607 9.99984L14.1762 13.1153C14.4691 13.4082 14.4691 13.8831 14.1762 14.176C13.8834 14.4689 13.4085 14.4689 13.1156 14.176L10.0001 11.0605L6.88458 14.176C6.59168 14.4689 6.11681 14.4689 5.82392 14.176C5.53102 13.8831 5.53102 13.4082 5.82392 13.1153L8.93942 9.99984L5.82392 6.88433Z"
          fill="white"
          fillOpacity="0.8"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id="filter0_di_2312_41422"
          x="2.60425"
          y="4.604"
          width="14.7917"
          height="14.7915"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2312_41422" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2312_41422" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="0.1" dy="0.1" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.95 0" />
          <feBlend mode="normal" in2="shape" result="effect2_innerShadow_2312_41422" />
        </filter>
        <linearGradient
          id="paint0_linear_2312_41422"
          x1="9.99992"
          y1="0.833496"
          x2="9.99992"
          y2="19.1668"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopOpacity="0.5" />
          <stop offset="1" stopOpacity="0.3" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default Dismissed
